import React, { useEffect } from 'react';
import { pages } from '@microsoft/teams-js';
import { IPublicClientApplication } from '@azure/msal-browser';
import { AppTheme } from '../types';

interface ViewProps { pca: IPublicClientApplication; theme: AppTheme; }

export default function ChannelTab(_: ViewProps) {
  useEffect(() => {
    if (pages.config.isSupported()) {
      pages.config.initialize();
      pages.config.registerOnSaveHandler((saveEvent: pages.config.SaveEvent) => {
        const projectId = new URLSearchParams(window.location.search).get('projectId') ?? '';
        pages.config.setConfig({
          entityId: projectId,
          contentUrl: `${process.env.REACT_APP_URL}/channel-tab?projectId=${projectId}`,
          suggestedDisplayName: 'Project',
        });
        saveEvent.notifySuccess();
      });
    }
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <h2>Project Channel Tab</h2>
      <p>Full board view — Phase 4</p>
    </div>
  );
}
